import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineFilmIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 2a1 1 0 0 0-1 1v2h-2V3a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 16 3v1H8V3a1 1 0 0 0-2 0v2H4V3a1 1 0 0 0-2 0v18a1 1 0 1 0 2 0v-2h2v2a1 1 0 1 0 2 0v-1h8v1a1.0001 1.0001 0 0 0 2 0v-2h2v2a1.0001 1.0001 0 0 0 2 0V3a1.0002 1.0002 0 0 0-1-1ZM6 17H4v-2h2v2Zm0-4H4v-2h2v2Zm0-4H4V7h2v2Zm10 9H8v-5h8v5Zm0-7H8V6h8v5Zm4 6h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2V7h2v2Z"/>
  </SvgIcon>
}

export default LineFilmIcon
